export default __webpack_public_path__ + "static/media/bde.62d7cf06.svg";